window.ProductDetails = window.ProductDetails || {};

const PRODUCT_DETAILS_API = "https://backoffice.banana-moon-clothing.co.uk/api/product/";

const ADDITIONAL_OPTIONS_KEY = "additionalOptions";
const CUSTOMISATION_POSITIONS_KEY = "customisationPositions";
const DESIGN_OPTIONS_KEY = "designOptions";
const GENERAL_OPTIONS_KEY = "generalOptions";
const NAMES_IN_NUMBER_KEY = "namesInNumbers";
const PRINT_OPTIONS_KEY = "printOptions";
const PRICING_KEY = "pricing";

const COLOURS_KEY = "colours";
const EMBROIDERY_KEY = "embroidery";
const FONTS_KEY = "fonts";
const PRINT_KEY = "print";

function sortAlphabetically (array, key) {
    return array.sort((a, b) => a[key].localeCompare(b[key]));
}

window.ProductDetails.getProductDetails = async function (productId) {
    let responseJSON = "";
    try {
        let response = await fetch(`${PRODUCT_DETAILS_API}${productId}/`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json"
            }
        });

        if (!response.ok) {
            let errorMessage = await response.text();

            console.error(`An error occurred. Status: ${response.status}, Status Text: ${response.statusText}, Message: ${errorMessage}`);
            throw new Error(`An error occurred. Status: ${response.status}`);
        }

        responseJSON = await response.json();

        return responseJSON;
    } catch (error) {
        console.error("Fetch error: " + error.message);
        throw error;
    }
}

window.ProductDetails.getAdditionalOptions = async function (productId, productDetailsJSON = null) {
    if (!productDetailsJSON)
        productDetailsJSON = await window.ProductDetails.getProductDetails(productId);

    return productDetailsJSON[ADDITIONAL_OPTIONS_KEY];
}

window.ProductDetails.getCustomisationPositions = async function (productId, productDetailsJSON = null) {
    if (!productDetailsJSON)
        productDetailsJSON = await window.ProductDetails.getProductDetails(productId);

    return productDetailsJSON[CUSTOMISATION_POSITIONS_KEY];
}

window.ProductDetails.getDesignOptions = async function (productId, productDetailsJSON = null) {
    if (!productDetailsJSON)
        productDetailsJSON = await window.ProductDetails.getProductDetails(productId);

    return productDetailsJSON[DESIGN_OPTIONS_KEY];
}

window.ProductDetails.getEmbroideryColours = async function (productId, productDetailsJSON = null) {
    if (!productDetailsJSON)
        productDetailsJSON = await window.ProductDetails.getProductDetails(productId);

    return sortAlphabetically(productDetailsJSON[PRINT_OPTIONS_KEY][EMBROIDERY_KEY][COLOURS_KEY][0][COLOURS_KEY], "label");
}

window.ProductDetails.getEmbroideryFonts = async function (productId, productDetailsJSON = null) {
    if (!productDetailsJSON)
        productDetailsJSON = await window.ProductDetails.getProductDetails(productId);

    return sortAlphabetically(productDetailsJSON[PRINT_OPTIONS_KEY][EMBROIDERY_KEY][FONTS_KEY], "font");
}

window.ProductDetails.getGeneralOptions = async function (productId, productDetailsJSON = null) {
    if (!productDetailsJSON)
        productDetailsJSON = await window.ProductDetails.getProductDetails(productId);

    return productDetailsJSON[GENERAL_OPTIONS_KEY];
}

window.ProductDetails.getNamesInNumber = async function (productId, productDetailsJSON = null) {
    if (!productDetailsJSON)
        productDetailsJSON = await window.ProductDetails.getProductDetails(productId);

    return productDetailsJSON[NAMES_IN_NUMBER_KEY];
}

window.ProductDetails.getPrintColours = async function (productId, productDetailsJSON = null) {
    if (!productDetailsJSON)
        productDetailsJSON = await window.ProductDetails.getProductDetails(productId);

    return sortAlphabetically(productDetailsJSON[PRINT_OPTIONS_KEY][PRINT_KEY][COLOURS_KEY][0][COLOURS_KEY], "label");
}

window.ProductDetails.getPrintFonts = async function (productId, productDetailsJSON = null) {
    if (!productDetailsJSON)
        productDetailsJSON = await window.ProductDetails.getProductDetails(productId);

    return sortAlphabetically(productDetailsJSON[PRINT_OPTIONS_KEY][PRINT_KEY][FONTS_KEY], "font");
}

window.ProductDetails.getPricing = async function (productId, productDetailsJSON = null) {
    if (!productDetailsJSON)
        productDetailsJSON = await window.ProductDetails.getProductDetails(productId);

    return productDetailsJSON[PRICING_KEY];
}